module.exports = __webpack_public_path__ + "media/images/voedselproductie-a829bd2dbb18f3ef596cc2af7d44fafc.jpg";